import { SERVICEDEFAULT as request } from "../request.js";

export function goLogin(param) {
    return request({
        url: '/api/auth/login',
        method: 'post',
        data: param
    }); 
}